import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08fddc61"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page good-detail"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "detail-info" }
const _hoisted_4 = { class: "info-top" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "童币", -1))
const _hoisted_6 = { class: "info-name" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-text" }, "宝贝详情", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = {
  key: 0,
  class: "footer-btn stock-none"
}
const _hoisted_12 = {
  key: 1,
  class: "footer-btn none"
}

import { Toast } from 'vant'
import { queryGoodDetail } from '@/apis/public';
import Divider from '@/components/Divider.vue'
import ExchangeModel from '@/components/ExchangeModel.vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const isExchangeModel = ref(false)
const goodInfo = ref(null)
const bannerList = ref([])
const handleQueryGoodDetail = async () => {
  const res = await queryGoodDetail({
    goodNo: route.query.goodNo
  })
  if (res.code === 0) {
    goodInfo.value = res.data
    bannerList.value = res.data.bannerImageList.slice(1, res.data.bannerImageList.length)

  } else {
    Toast(res.message)
  }
}
const handleBuy = () => {
  isExchangeModel.value = true
}
const handleNoBuy = () => {
  isExchangeModel.value = false
}
handleQueryGoodDetail()

return (_ctx: any,_cache: any) => {
  return (goodInfo.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (goodInfo.value.bannerImageList[0])
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "detail-img",
              src: goodInfo.value.bannerImageList[0],
              alt: ""
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(goodInfo.value.goldPayPrice), 1),
              _hoisted_5
            ]),
            _createElementVNode("div", null, "剩余：" + _toDisplayString(goodInfo.value.stockNum) + "件", 1)
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(goodInfo.value.goodName), 1)
        ]),
        (bannerList.value.length > 1)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(bannerList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: index,
                class: "detail-img",
                src: item,
                alt: ""
              }, null, 8, _hoisted_7))
            }), 128))
          : _createCommentVNode("", true),
        _createVNode(Divider, null, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodInfo.value.detailImageList, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            class: "detail-img",
            src: item,
            alt: ""
          }, null, 8, _hoisted_9))
        }), 128)),
        _createElementVNode("div", _hoisted_10, [
          (goodInfo.value.stockNum === 0 || goodInfo.value.stockNum < goodInfo.value.purchaseMin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "库存不足"))
            : (goodInfo.value.enoughGold === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "童币不足"))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "footer-btn active",
                  onClick: handleBuy
                }, "立即兑换"))
        ]),
        (isExchangeModel.value)
          ? (_openBlock(), _createBlock(ExchangeModel, {
              key: 2,
              goodInfo: goodInfo.value,
              onClose: handleNoBuy
            }, null, 8, ["goodInfo"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})